import { EmptyState } from './StateBlock';
import styles from './parts.module.css';

/** Semantic table: caption, scoped column headers, sticky header inside its own scroll container. */
/** `onRowClick` is a mouse convenience only; keyboard users get real links/buttons inside the cells. */
const DataTable = ({ caption, columns, rows, rowKey, empty = 'Nothing to show.', onRowClick }) => {
    if (rows.length === 0) return <EmptyState>{empty}</EmptyState>;
    return (
        <div className={styles.tableWrap} tabIndex={0} role="region" aria-label={caption}>
            <table className={styles.table}>
                <caption className={styles.sr}>{caption}</caption>
                <thead>
                    <tr>
                        {columns.map(column => (
                            <th key={column.key} scope="col">
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => (
                        <tr key={rowKey(row)} onClick={onRowClick ? () => onRowClick(row) : undefined}>
                            {columns.map(column => (
                                <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;
